import Backdrop from '@material-ui/core/Backdrop';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import Grid from '@material-ui/core/Grid';
import { useSnackbar } from 'notistack';
import React, { useEffect, useRef, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import * as Yup from 'yup';
import TextField from '../../components/Form/TextField';
import LoadingUI from '../../components/ui/LoadingUI';
import { useAuth } from '../../hooks/auth';
import { MovementType, MovementTypePost, MovementTypePut } from '../../interfaces/MovementType';
import MovementTypeApi from '../../services/MovementTypeApi';
import { useStyles } from './Style';

type Props = {
    id: number,
    description: string,
    clickHandlerCalbkack?: () => void,
    clickHandlerClose?: () => void,
    handleSetSuccess?: (value: boolean) => void,
}

interface IFormInput {
    id: any;
    description: any;
    plantId: any;
}

const MovementTypeForm: React.FC<Props> = (props) => {
    const classes = useStyles();
    const [movementType, setMovementType] = useState<MovementType | any>();
    const [openBackdrop, setOpenBackdrop] = useState(false);
    const { t } = useTranslation("MovementType");
    const [loading, setLoading] = useState(true);
    const { t: tval } = useTranslation("Validation");
    const { enqueueSnackbar } = useSnackbar();
    const { user } = useAuth();
    const { control, handleSubmit, clearErrors, setError, setValue } = useForm<IFormInput>(
        {
            defaultValues: { id: 0, description: '' }
        }
    )

    const refCode = useRef<HTMLElement>(null)
    const refDescription = useRef<HTMLElement>(null)

    const getMovementType = () => {
        if (props.description !== '' && props.id !== 0) {
            MovementTypeApi.getMovementType(props.id).then((result) => {
                if (result) {
                    setMovementType(result)
                    setValue("id", result.id)
                    setValue("description", result.description)
                }
            }).finally(() => {
                setLoading(false);
            });
        }
        else {
            setLoading(false);
            setMovementType(null)
        }
    }

    useEffect(() => {
        getMovementType()
    }, [props])

    
    useEffect(() => {
        if (props.description != '')
            refDescription.current?.focus()
        else
            refCode.current?.focus()
        
    }, [props.description])

    

    const yupValidation = async (data: any) => {

        var result = false
        clearErrors(["id", "description"])

        try {
            const schema = Yup.object().shape({
                description: Yup.string().required(tval("requiredField")),
            })

            await schema.validate(data, {
                abortEarly: false,
            })

            result = true
        } catch (err) {
            
            if (err instanceof Yup.ValidationError) {
                err.inner.forEach(error => {
                    setError(error.path?.split('.')[0] as "id" | "description", { message: error.message })
                })
            }

            result =  false
        }

        return result
    }

    const saveData = async (data: any) => {
        setOpenBackdrop(true);
        var validForm = await yupValidation(data)

        if (validForm == false)
            return
        
        if (props.id && props.description != '') {
            let put:MovementTypePut = {
                id: props.id,
                description: data.description,
                plantId: Number(user.company.plantID),
            }

            handleSubmitPut(put)
        }
        else{
            let post:MovementTypePost = {
                id: props.id,
                description: data.description,
                plantId: Number(user.company.plantID),
            }

            handleSubmitPost(post)
        }
        setLoading(false);
    }

    const handleSubmitPost = (data: MovementTypePost) => {
        setOpenBackdrop(true);
        MovementTypeApi.postMovementType(data)
            .then(result => {
                enqueueSnackbar(t("returnSubmitFormSuccess"), { variant: 'success' });
                if (props && props.handleSetSuccess)
                    props.handleSetSuccess(true);
                if (props && props.clickHandlerCalbkack)
                    props.clickHandlerCalbkack()
            }).finally(() => {
                setOpenBackdrop(false);
            });
    }

    const handleSubmitPut = (data: MovementTypePut) => {
        setOpenBackdrop(true);
        MovementTypeApi.putMovementType(data)
                .then(result => {
                    enqueueSnackbar(t("returnSubmitEditFormSuccess"), { variant: 'success' });
                    if (props && props.handleSetSuccess)
                        props.handleSetSuccess(true);
                    if (props && props.clickHandlerCalbkack)
                        props.clickHandlerCalbkack()
                }).finally(() => {
                    setOpenBackdrop(false);
                });
    }

    return (
        <div>
        {
            loading ?
            <LoadingUI />
            :
            <React.Fragment>
                <Backdrop className={classes.backdrop} open={openBackdrop}>
                    <CircularProgress color="inherit" />
                </Backdrop>

                <form onSubmit={handleSubmit(saveData)} >     
                    <Grid container spacing={1}>
                        <Grid item xs={12}>
                            <TextField 
                                label={t("description")} 
                                name="description" 
                                control={control} 
                                inputRef={refDescription}
                                fullWidth
                                style={{ margin: '0px' }}
                                inputProps={{ maxLength: 50 }} /> 
                        </Grid>
                    </Grid>
                    <Grid container style={{ marginTop: 30 }} spacing={2}>
                        <Grid item  xs={12} className={classes.footForm}>
                            <Button variant="contained" className={classes.rootCancelButton} onClick={() => props && props.clickHandlerClose ? props.clickHandlerClose() : null}>
                                {t("cancel")}
                            </Button>
                            <Button type="submit" variant="contained" color="primary" className={classes.rootButton}>
                                {t("confirm")}
                            </Button>
                        </Grid>
                    </Grid>
                </form>
            </React.Fragment>
        }
        </div>
    )
}
export default MovementTypeForm;
